import React from 'react';

export const VisibilityOff = () => (
	<svg width='18' height='18' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M1.31783 6.48226C2.087 6.17459 2.95996 6.54871 3.26763 7.31789L1.87491 7.87497C3.26763 7.31789 3.26741 7.31734 3.2672 7.31682L3.26686 7.31597L3.26642 7.31488L3.26631 7.31461C3.26631 7.31461 3.26639 7.31481 3.26655 7.31519L3.27084 7.32558C3.27549 7.33677 3.28375 7.35638 3.29565 7.38385C3.31946 7.43881 3.35782 7.52508 3.41114 7.63818C3.51789 7.86462 3.68391 8.19714 3.91236 8.6003C4.37097 9.4096 5.07177 10.4869 6.03671 11.559C7.96451 13.701 10.8703 15.75 14.9999 15.75C19.1294 15.75 22.0353 13.701 23.9631 11.559C24.928 10.4869 25.6288 9.4096 26.0875 8.60029C26.3159 8.19713 26.4819 7.86461 26.5887 7.63817C26.642 7.52507 26.6804 7.4388 26.7042 7.38384C26.7161 7.35637 26.7243 7.33676 26.729 7.32557L26.7326 7.31682L26.733 7.31598C27.0413 6.54809 27.9135 6.17484 28.682 6.48226C29.4512 6.78993 29.8253 7.66289 29.5176 8.43206L28.1249 7.87497C29.5176 8.43206 29.5174 8.43268 29.5171 8.43334L29.5165 8.43484L29.515 8.43849L29.511 8.44835L29.4987 8.47816C29.4886 8.50244 29.4747 8.53548 29.4568 8.57667C29.4211 8.65904 29.3698 8.77419 29.3023 8.91744C29.1673 9.20369 28.9671 9.60359 28.6975 10.0793C28.16 11.0278 27.3374 12.2943 26.193 13.5659C25.9618 13.8227 25.7168 14.0805 25.4576 14.3364L28.2481 17.1268C28.8339 17.7126 28.8339 18.6623 28.2481 19.2481C27.6623 19.8339 26.7125 19.8339 26.1268 19.2481L23.1328 16.2541C21.3511 17.4633 19.1516 18.4118 16.4999 18.6762L16.4999 21.9375C16.4999 22.7659 15.8283 23.4375 14.9999 23.4375C14.1715 23.4375 13.4999 22.7659 13.4999 21.9375L13.4999 18.6762C10.8482 18.4118 8.64874 17.4633 6.86704 16.2542L3.87307 19.2481C3.28728 19.8339 2.33754 19.8339 1.75175 19.2481C1.16596 18.6623 1.16596 17.7126 1.75175 17.1268L4.54216 14.3364C4.283 14.0805 4.03796 13.8227 3.80683 13.5659C2.66241 12.2943 1.83978 11.0278 1.30229 10.0793C1.03271 9.60359 0.832511 9.20369 0.697563 8.91743C0.630032 8.77418 0.578671 8.65903 0.542979 8.57666C0.525127 8.53547 0.511179 8.50244 0.501073 8.47815L0.488781 8.44834L0.484778 8.43848L0.483309 8.43483L0.482707 8.43334C0.482444 8.43268 0.482194 8.43205 1.87491 7.87497L0.482194 8.43205C0.174526 7.66288 0.548652 6.78992 1.31783 6.48226Z'
			fill='#292929'
		/>
	</svg>
);
export const Visibility = () => (
	<svg width='18' height='18' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M3.52604 15C3.62549 15.1999 3.75394 15.4456 3.91245 15.7253C4.37106 16.5346 5.07186 17.6119 6.0368 18.6841C7.9646 20.8261 10.8704 22.875 15 22.875C19.1295 22.875 22.0354 20.8261 23.9632 18.6841C24.9281 17.6119 25.6289 16.5346 26.0875 15.7253C26.2461 15.4456 26.3745 15.1999 26.474 15C26.3745 14.8001 26.2461 14.5544 26.0875 14.2747C25.6289 13.4654 24.9281 12.3881 23.9632 11.3159C22.0354 9.17394 19.1295 7.125 15 7.125C10.8704 7.125 7.9646 9.17394 6.0368 11.3159C5.07186 12.3881 4.37106 13.4654 3.91245 14.2747C3.75394 14.5544 3.62549 14.8001 3.52604 15ZM28.125 15C29.5177 14.4429 29.5175 14.4423 29.5172 14.4416L29.5166 14.4401L29.5151 14.4365L29.5111 14.4266L29.4988 14.3968C29.4887 14.3725 29.4748 14.3395 29.4569 14.2983C29.4212 14.2159 29.3699 14.1008 29.3023 13.9575C29.1674 13.6713 28.9672 13.2714 28.6976 12.7956C28.1601 11.8471 27.3375 10.5806 26.1931 9.30905C23.9021 6.76356 20.2454 4.125 15 4.125C9.7545 4.125 6.09786 6.76356 3.80692 9.30905C2.6625 10.5806 1.83987 11.8471 1.30238 12.7956C1.0328 13.2714 0.832601 13.6713 0.697652 13.9575C0.630122 14.1008 0.57876 14.2159 0.543068 14.2983C0.525216 14.3395 0.511269 14.3725 0.501162 14.3968L0.488871 14.4266L0.484867 14.4365L0.483398 14.4401L0.482797 14.4416C0.482533 14.4423 0.482283 14.4429 1.875 15L0.482283 14.4429C0.339239 14.8005 0.339239 15.1995 0.482283 15.5571L1.875 15C0.482283 15.5571 0.482533 15.5577 0.482797 15.5584L0.483398 15.5599L0.484867 15.5635L0.488871 15.5734L0.501162 15.6032C0.511269 15.6275 0.525216 15.6605 0.543068 15.7017C0.57876 15.7841 0.630122 15.8992 0.697652 16.0425C0.832601 16.3287 1.0328 16.7286 1.30238 17.2044C1.83987 18.1529 2.6625 19.4194 3.80692 20.6909C6.09786 23.2364 9.7545 25.875 15 25.875C20.2454 25.875 23.9021 23.2364 26.1931 20.6909C27.3375 19.4194 28.1601 18.1529 28.6976 17.2044C28.9672 16.7286 29.1674 16.3287 29.3023 16.0425C29.3699 15.8992 29.4212 15.7841 29.4569 15.7017C29.4748 15.6605 29.4887 15.6275 29.4988 15.6032L29.5111 15.5734L29.5151 15.5635L29.5166 15.5599L29.5172 15.5584C29.5175 15.5577 29.5177 15.5571 28.125 15ZM28.125 15L29.5177 15.5571C29.6608 15.1995 29.6608 14.8005 29.5177 14.4429L28.125 15ZM9.75 15C9.75 12.1005 12.1005 9.75 15 9.75C17.8995 9.75 20.25 12.1005 20.25 15C20.25 17.8995 17.8995 20.25 15 20.25C12.1005 20.25 9.75 17.8995 9.75 15ZM15 12.75C13.7574 12.75 12.75 13.7574 12.75 15C12.75 16.2426 13.7574 17.25 15 17.25C16.2426 17.25 17.25 16.2426 17.25 15C17.25 13.7574 16.2426 12.75 15 12.75ZM3.26664 14.4402C3.26637 14.4396 3.26633 14.4395 3.26651 14.4399L3.26664 14.4402Z'
			fill='#292929'
		/>
	</svg>
);

export const LogoutIcon = () => (
	<svg width='18' height='18' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M12.9751 28.125C12.9751 27.2966 13.6467 26.625 14.4751 26.625L26.6251 26.625L26.6251 3.375L14.4751 3.375C13.6467 3.375 12.9751 2.70343 12.9751 1.875C12.9751 1.04657 13.6467 0.375 14.4751 0.375L28.1251 0.374999C28.9535 0.374999 29.6251 1.04657 29.6251 1.875L29.6251 28.125C29.6251 28.9534 28.9535 29.625 28.1251 29.625L14.4751 29.625C13.6467 29.625 12.9751 28.9534 12.9751 28.125Z'
			fill='#292929'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M23.325 15C23.325 14.1716 22.6534 13.5 21.825 13.5L5.39428 13.5L9.25703 9.47628C9.83075 8.87866 9.81137 7.92911 9.21375 7.3554C8.61613 6.78169 7.66658 6.80107 7.09287 7.39868L0.792874 13.9612C0.251629 14.525 0.233981 15.4099 0.752316 15.9948L7.05231 23.1042C7.60174 23.7242 8.54977 23.7814 9.16978 23.232C9.7898 22.6826 9.84702 21.7345 9.29759 21.1145L5.20839 16.5L21.825 16.5C22.6534 16.5 23.325 15.8284 23.325 15Z'
			fill='#292929'
		/>
	</svg>
);

export const SwitchToAdmin = () => (
	<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M7.40643 3.4825C7.40643 4.69073 6.82632 5.23833 5.625 5.23833C4.42367 5.23833 3.87723 4.69073 3.87723 3.4825C3.87723 2.27427 4.42367 1.75 5.625 1.75C6.82632 1.75 7.40643 2.27427 7.40643 3.4825Z'
			stroke='#292929'
			strokeWidth='1.6'
			strokeLinecap='round'
			stroke-linejoin='round'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M9.25 10.75L2 10.75C2 10.2319 2 10.189 2 9.74272C2 8.53381 2.97378 7.55417 4.175 7.55417L7.075 7.55417C8.27622 7.55417 9.25 8.53381 9.25 9.74272C9.25 10.189 9.25 10.2319 9.25 10.75Z'
			stroke='#292929'
			strokeWidth='1.6'
			strokeLinecap='round'
			stroke-linejoin='round'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M16.4064 10.7325C16.4064 11.9407 15.8263 12.4883 14.625 12.4883C13.4237 12.4883 12.8772 11.9407 12.8772 10.7325C12.8772 9.52427 13.4237 9 14.625 9C15.8263 9 16.4064 9.52427 16.4064 10.7325Z'
			stroke='#292929'
			strokeWidth='1.6'
			strokeLinecap='round'
			stroke-linejoin='round'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M18.25 18.0609L11 18.0609C11 17.5428 11 17.4999 11 16.9927C11 15.7838 11.9738 14.8042 13.175 14.8042L16.075 14.8042C17.2762 14.8042 18.25 15.7838 18.25 16.9927C18.25 17.4999 18.25 17.5428 18.25 18.0609Z'
			stroke='#292929'
			strokeWidth='1.6'
			strokeLinecap='round'
			stroke-linejoin='round'
		/>
		<path
			d='M11.125 2H15.5C16.0523 2 16.5 2.44772 16.5 3V6.625'
			stroke='#292929'
			strokeWidth='1.6'
			strokeLinecap='round'
			stroke-linejoin='round'
		/>
		<path
			d='M18.4666 4.73328L16.4833 6.71652L14.5001 4.73328'
			stroke='#292929'
			strokeWidth='1.6'
			strokeLinecap='round'
			stroke-linejoin='round'
		/>
		<path
			d='M7.5 18.1249L4.21646 18.1249C3.66418 18.1249 3.21646 17.6772 3.21646 17.1249L3.21646 13.5914'
			stroke='#292929'
			strokeWidth='1.6'
			strokeLinecap='round'
			stroke-linejoin='round'
		/>
		<path
			d='M1.25 15.4833L3.23325 13.5L5.21649 15.4833'
			stroke='#292929'
			strokeWidth='1.6'
			strokeLinecap='round'
			stroke-linejoin='round'
		/>
	</svg>
);
export const WhatsNewIcon = () => (
	<svg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<g clip-path='url(#clip0_3763_212118)'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M27.7855 21.4695C27.7173 21.4878 27.6469 21.4935 27.5743 21.4866L14.0054 20.0514L16.4703 27.2323C16.5308 27.3863 16.5227 27.5575 16.4482 27.7045C16.3748 27.8512 16.2421 27.9599 16.0822 28.0027L10.9504 29.6564C10.6719 29.731 10.381 29.5896 10.2679 29.3238L7.14671 20.8996C6.15865 20.8619 5.26593 20.1886 4.99689 19.1845L4.09784 15.8293C3.76729 14.5957 4.5017 13.3237 5.73532 12.9931L9.54461 11.9724L22.4994 2.54736C22.6548 2.4338 22.8527 2.40716 23.0338 2.47012C23.2137 2.53338 23.3505 2.68134 23.3999 2.86588L28.1949 20.7605C28.2443 20.945 28.1999 21.1415 28.0756 21.2863C27.9979 21.3767 27.8973 21.4396 27.7855 21.4695ZM11.6419 19.8015L9.53503 20.366L11.7625 26.0487C11.9593 26.5509 12.5231 26.8017 13.0279 26.6118C13.5274 26.4239 13.7868 25.8725 13.613 25.3678L11.6985 19.8074L11.6419 19.8015ZM12.7988 16.9683L24.8681 18.4728L21.4579 6.87151L11.7623 13.4244L12.7988 16.9683ZM6.25648 16.406C6.09105 15.7886 6.45785 15.1533 7.07522 14.9879L8.41794 14.4859L9.98059 18.0199L8.53343 18.7036C7.91605 18.869 7.06881 18.6372 6.90338 18.0199L6.25648 16.406Z'
				fill='#292929'
			/>
		</g>
		<defs>
			<clipPath id='clip0_3763_212118'>
				<rect width='30' height='30' fill='white' />
			</clipPath>
		</defs>
	</svg>
);
